import type { ButtonTone } from './types';

export const TONE_GRADIENTS: Record<ButtonTone, string> = {
  brand: 'bg-grad dark:bg-grad-dark',
  info: 'bg-grad-blue',
  success: 'bg-grad-green',
  warning: 'bg-grad-amber',
  danger: 'bg-grad-red',
};
